import React from 'react';
import { WidgetPoints } from 'src/components/modules/points/types/pointsWidgetstypes';
import PointsUI from 'src/components/ui/pointsUI';
import Input from 'src/components/ui/pointsUI/integerInputBase';
import { Grid, Typography } from '@material-ui/core';
import { timeUnits, TimeUnit } from 'src/components/modules/points/types/widgetTypes';
import { getPointId } from 'src/components/modules/points/helpers';

const getTimeWidgetSeparator = (timeUnit?: TimeUnit): string => {
  return timeUnit === timeUnits.year || timeUnit === timeUnits.month || timeUnit === timeUnits.day
    ? '/'
    : ':';
};

type TimeWidgetProps = {
  onChange: (point: WidgetPoints, value: string | number | string[]) => void;
  setInputsError?: (value: boolean) => void;
  inputValues: Record<string, string | number | string[]>;
  points: WidgetPoints[];
  title: string;
};

const getTimeUnitConfig = (timeUnit: TimeUnit) => {
  const config = {
    [timeUnits.year]: { label: 'Year', placeholder: 'YYYY' },
    [timeUnits.month]: { label: 'Month', placeholder: 'MM' },
    [timeUnits.day]: { label: 'Day', placeholder: 'DD' },
    [timeUnits.hour]: { label: 'Hour', placeholder: 'HH' },
    [timeUnits.minute]: { label: 'Minute', placeholder: 'MM' },
    [timeUnits.second]: { label: 'Second', placeholder: 'SS' },
  };
  return config[timeUnit] || { label: '', placeholder: '' };
};

const TimeWidget: React.FC<TimeWidgetProps> = ({ onChange, inputValues, points, title }) => {
  const datePoints = points
    .filter((point: WidgetPoints) =>
      ([timeUnits.month, timeUnits.day, timeUnits.year] as TimeUnit[]).includes(
        point.timeUnit?.[0] as TimeUnit
      )
    )
    .sort((a: WidgetPoints, b: WidgetPoints) => {
      const order: readonly TimeUnit[] = [timeUnits.month, timeUnits.day, timeUnits.year] as const;
      return (
        order.indexOf(a.timeUnit?.[0] as TimeUnit) - order.indexOf(b.timeUnit?.[0] as TimeUnit)
      );
    });

  const timePoints = points.filter((point: WidgetPoints) =>
    ([timeUnits.hour, timeUnits.minute, timeUnits.second] as TimeUnit[]).includes(
      point.timeUnit?.[0] as TimeUnit
    )
  );

  const renderInputGroup = (groupPoints: WidgetPoints[]) => (
    <Grid container alignItems="center">
      {groupPoints.map((point, index) => (
        <React.Fragment key={point.address}>
          <Grid item xs>
            <Input
              value={Number(inputValues[getPointId(point)])}
              keyData={point.address}
              onKeyChange={(_key, value) => onChange(point, value)}
              point={point}
              label={getTimeUnitConfig(point.timeUnit?.[0] as TimeUnit).label}
              placeholder={getTimeUnitConfig(point.timeUnit?.[0] as TimeUnit).placeholder}
            />
          </Grid>
          {index < groupPoints.length - 1 && (
            <Grid item style={{ width: '18px' }}>
              <Typography variant="body1" style={{ textAlign: 'center' }}>
                {getTimeWidgetSeparator(point.timeUnit?.[0] as TimeUnit)}
              </Typography>
            </Grid>
          )}
        </React.Fragment>
      ))}
    </Grid>
  );

  return (
    <PointsUI title={title} readOnly={points[0].readOnly}>
      <Grid container direction="column" spacing={2} style={{ marginTop: 10 }}>
        <Grid item>{renderInputGroup(datePoints)}</Grid>
        <Grid item>{renderInputGroup(timePoints)}</Grid>
      </Grid>
    </PointsUI>
  );
};

export default TimeWidget;
